// presentational component

import AppSectionErrorBoundary from './AppSectionErrorBoundary';

// NO logic should be here
export const AppCard = ({ children, title, className }: { children: React.ReactNode; title?: string; className?: string }) => {
  return (
    <AppSectionErrorBoundary>
      <article className={`card ${className}`}>
        {title && (
          <header className=' border-bottom '>
            <h3 className='font-18 font-500 text-uppercase line-height-26 mb-0 text-nowrap'>{title}</h3>
          </header>
        )}
        <div>{children}</div>
      </article>
    </AppSectionErrorBoundary>
  );
};

export default AppCard;
